//@flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@components";
import { SchemaForm } from "@components";
import uiSchema from "./__ui__/schema";
type Props = $Exact<{
  title: string,
  submitButtonText: string,
  submitButtonIcon: string,
  onDismissHandler: Function,
  onSubmit: Function,
  schema: Object,
  formData?: Object,
  ...PropsFromLocalize,
}>;
type StateProps = $Exact<{
  ...StaffGroupFormData,
}>;

export type StaffGroupFormData = $Exact<{
  name: ?string,
  staffGroupType: {
    id: ?number,
  },
}>;

export class AddEditStaffGroupModal extends React.Component<Props, StateProps> {
  state = {
    staffGroupType: { id: null },
    name: null,
  };
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ ...this.props.formData });
  }

  submitForm = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  onChange = (formData: Object) => {
    this.setState({ ...formData });
  };

  get isValid() {
    return !!this.state.name && this.state.name.trim() && this.state.staffGroupType.id;
  }

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader toggle={this.props.onDismissHandler}>{this.props.title}</ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            schema={this.props.schema}
            onSubmit={this.props.onSubmit}
            onChange={this.onChange}
            uiSchema={uiSchema}
            externalSubmit
            formData={this.state}
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler} data-dismiss="modal">
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon={this.props.submitButtonIcon}
            onClick={this.submitForm}
            disabled={!this.isValid}
          >
            {this.props.submitButtonText}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AddEditStaffGroupModal);
